import enMessages from './en';
import itMessages from './it';
import frMessages from './fr';

export const en = enMessages;
export const it = itMessages;
export const fr = frMessages;


// WEBPACK FOOTER //
// ./src/i18n/index.js